export const COMMUNITY_CONTRIBUTION_PART_OPTIONS = [
    { value: 'alto', label: 'Alto' },
    { value: 'tenor', label: 'Tenor' },
    { value: 'soprano', label: 'Soprano' },
    { value: 'bass', label: 'Bass' },
    { value: 'piano', label: 'Piano' },
    { value: 'drummer', label: 'Drummer' },
    { value: 'guitarist', label: 'Guitarist' },
    { value: 'keyboardist', label: 'Keyboardist' },
    { value: 'bass_guitarist', label: 'Bass Guitarist' },
    { value: 'saxophonist', label: 'Saxophonist' },
    { value: 'trumpeter', label: 'Trumpeter' },
    { value: 'violinist', label: 'Violinist' },
    { value: 'cellist', label: 'Cellist' },
    { value: 'flutist', label: 'Flutist' },
    { value: 'percussionist', label: 'Percussionist' },
    { value: 'synth', label: 'Synth' },
    { value: 'horns', label: 'Horns' },
    { value: 'woodwind', label: 'Woodwind' },
    { value: 'brass', label: 'Brass' },
    { value: 'choir', label: 'Choir' },
] as const;

export const COMMUNITY_VOCAL_FILTER_OPTIONS = COMMUNITY_CONTRIBUTION_PART_OPTIONS.filter(({ value }) =>
    ['tenor', 'alto', 'soprano', 'bass'].includes(value)
);
